export enum PeriodTypeEnum {
    Quarter = "QUARTER",
    Semester = "SEMESTER",
    FullFiscalYear = "FULL_FISCAL_YEAR",
    LastTwelveMonths = "LAST_TWELVE_MONTHS",
    YearToDate = "YEAR_TO_DATE",
}
